import { Dropdown, Menu } from "@mui/base";
import { columnFetcher, Listbox, MenuButton, MenuItem } from "../../Style";
import {
  Box,
  Button,
  InputAdornment,
  TextField,
  Typography
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import SearchIcon from "@mui/icons-material/Search";
import "../../styles/App.scss";
import "../../styles/UserStyles.css";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import FilterIcon from "@mui/icons-material/Tune";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import UploadCSVDialog from "./UploadCSVDialog";
import InstantBookingButton from "../../Screens/Booking/InstantBookingButton";
const SearchAndButtonTab = ({
  searchQuery,
  searchColumn,
  columns,
  setSearchColumn,
  setSearchQuery,
  handleUploadCSV,
  handleExport,
  title,
  type,
  routeName,
  permissions,
  user
}) => {
  const navigate = useNavigate();
  const isAdmin = user?.user_type === 1;

  const handleColumnChange = (event) => {
    setSearchColumn(event);
    setSearchQuery("");
  };

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleOpenDialog = () => setIsDialogOpen(true);
  const handleCloseDialog = () => setIsDialogOpen(false);

  const showAddButton = () => {
    if (title === "Bookings") {
      return (
        user?.role === "Customer" ||
        user?.role === "Vendor" ||
        permissions?.bookings?.add === true ||
        isAdmin
      );
    }
    if (isAdmin || ["Vendors", "Customers", "Roles"].includes(title)) {
      return true;
    }

    switch (title) {
      case "Services":
        return permissions?.services?.add === true;
      case "Airports":
        return permissions?.airports?.add === true;
      case "Staffs":
        return permissions?.staffs?.add === true;
      default:
        return false;
    }
  };
  return (
    <>
      <Box className="action-container">
        <Box>
          <Typography variant="h5" className="form-heading">
            {title}
          </Typography>
        </Box>
        <Box className="view-navbar-tab">
          <Box className="search-container">
            <TextField
              variant="outlined"
              placeholder={` Search ${title}... `}
              size="small"
              className="search-input"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
            />
            <Dropdown>
              <MenuButton>
                <FilterIcon color="blue" />
                Filter
                <KeyboardArrowDownIcon className="caret" />
              </MenuButton>
              <Menu slots={{ listbox: Listbox }}>
                {columns.map((column) => (
                  <MenuItem
                    key={column.value}
                    onClick={() => handleColumnChange(column.value)}
                  >
                    {column.label}
                  </MenuItem>
                ))}
              </Menu>
            </Dropdown>
          </Box>
          <Box className="navbar-button-container">
            <Button
              variant="outlined"
              type="button"
              startIcon={<DownloadIcon />}
              size="small"
              className="export-button"
              onClick={handleExport}
            >
              Export
            </Button>
            {!["Bookings", "Roles"].includes(title) && (
              <Button
                variant="contained"
                component="label"
                size="small"
                className={"upload-button"}
                onClick={handleOpenDialog}
              >
                Upload CSV
              </Button>
            )}

            {showAddButton() && title !== "Payments" && (
              <Button
                variant="contained"
                size="small"
                className={
                  title === "Bookings" || title === "Roles"
                    ? "upload-button"
                    : "add-button"
                }
                onClick={() => {
                  navigate(routeName);
                }}
              >
                Add {title.slice(0, -1)}
              </Button>
            )}

            {title === "Bookings" && <InstantBookingButton user={user} />}
          </Box>
        </Box>
      </Box>
      <UploadCSVDialog
        open={isDialogOpen}
        onClose={handleCloseDialog}
        type={type}
      />
    </>
  );
};

export default SearchAndButtonTab;
